import { call, put, select, take, takeLatest } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"
import { PROGRAM } from "../../constants/state"
import { onError } from "./helpers/request"


const cliMoviesSelector = state => state.getIn([PROGRAM, 'cliMovies', 'items'])


function* putMapping(type, metaMoviePk, brandPk) {
    yield put({
        type: type, 
        payload: {
            metaMoviePk: metaMoviePk, 
            brandPk: brandPk
        }
    })
}


function* updateBrandMovieMappings({payload}) {
    try {
        const mappings = yield payload.mappings 
        const mappingKeys = yield Object.keys(mappings)
        const cliMovies = yield select(cliMoviesSelector)

        for(let m = 0; m < mappingKeys.length; m++) {
            const moviePk = yield mappingKeys[m]
            const oldBrandPk = yield cliMovies.getIn([moviePk, 'brand', 'pk'], null)
            const newBrandPk = yield mappings[moviePk] ? mappings[moviePk].pk : null

            if(oldBrandPk === newBrandPk) {
                continue
            } else if(null === newBrandPk) {
                yield call(putMapping, actionTypes.BRAND_MOVIE_MAPPINGS_DELETE_ITEM, moviePk, oldBrandPk)
                yield take(actionTypes.PROGRAM_UPDATE_ITEM_LOCAL_DELETE)
            } else {
                yield call(putMapping, actionTypes.BRAND_MOVIE_MAPPINGS_CREATE_ITEM, moviePk, newBrandPk)
                yield take(actionTypes.PROGRAM_UPDATE_ITEM_LOCAL_UPDATE)
            }
        }

        yield put({type: actionTypes.BRAND_MOVIE_MAPPINGS_UPDATE_SUCCESS})
    } catch(e)  {
        yield call(onError, actionTypes.BRAND_MOVIE_MAPPINGS_UPDATE_ERROR, e.message)
    }
}


export function* watchBrandMovieMappingsUpdate() {
    try {
        yield takeLatest(actionTypes.BRAND_MOVIE_MAPPINGS_UPDATE_REQUEST, updateBrandMovieMappings)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}